import global from './Globals';

const Typography = {
  fontColour: global.black,
  editText: global.grey600,
};

export default Typography;
